<template>
  <div>
    <TextBody custom-class="mb-4" :text="t$('.text')"></TextBody>
    <Button @click="scrollToPostform" class="mt-4">Fotos hochladen</Button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TextBody from "components/UI/TextBody.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import Hyperlink from "components/UI/Hyperlink.vue"
import Button from "components/UI/Button.vue"

export default defineComponent({
  name: "EventPassedContent",
  components: { Button, Hyperlink, TextBody },
  setup() {
    const { t$ } = useTranslate("components.event_card.body_text.EVENT_PASSED")

    const scrollToPostform = () => {
      const postform = document.getElementById("suus__post-form")
      if (postform) {
        postform.scrollIntoView({ behavior: "smooth" })
      }
    }

    return { t$, scrollToPostform }
  },
})
</script>
